module.exports = __webpack_public_path__ + "img/mpp_image.62f1ba2c.png";